import { createSelector } from 'reselect';
import { getMachineOperationalStatus } from './getMachineOperationalStatus';
import { getWaitingForWorkEnabled } from './getWaitingForWorkEnabled';

export const getIsWaitingForWork = createSelector(
  [getMachineOperationalStatus, getWaitingForWorkEnabled],
  (machineOperationalStatus, waitingForWorkEnabled) => {
    return (
      waitingForWorkEnabled &&
      machineOperationalStatus?.status === 'waiting_for_work'
    );
  }
);
